/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../apimodel.d.ts" />
/// <reference path="app.common.filters.module.ts" />

module App.Common.Filters {
	'use strict';

	function filter(input: Hca.HiLO.ViewModel.IAddressViewModel): string {
		if (!input) {
			return '';
		}

		var addressLines = [
			input.line1,
			input.line2,
			input.line3,
			input.line4,
			input.townOrCity,
			input.county			
		];

		//compact
		var addressLinesCompacted = _.compact(addressLines).join(', ');
		var postCodeCompacted = _.compact([input.postcode]);

		//concatinate
		var singleLine = `${addressLinesCompacted} ${postCodeCompacted}`;

		//ensure there is no double commas or spaces
		singleLine = singleLine.replace(`,,`, `,`).replace(`  `, ` `);
	
		return singleLine.trim();
	}

	angular
		.module('app.common.filters')
		.filter('singlelineAddress', [() => { return filter; }]);
}